// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"13ff18e3","453":"ccadd3be","476":"a0f9b2d6"}[chunkId] + ".chunk.js";
};